export const STATUS = Object.freeze({
  error: 'error',
  loading: 'loading',
  rejected: 'rejected',
  accepted: 'accepted',
  temporary: 'temporary',
  marked_for_leave: 'marked_for_leave',
  waiting_confirmation: 'waiting_confirmation'
})

export const ROLE = Object.freeze({
  admin: 'admin',
  member: 'member'
})
